import CodeSend from './CodeSend'
export default CodeSend
